export function getStyleNameFromAttribute(span: HTMLSpanElement): string | null {
	// Zepto uses data-value for style elements, not data-style
	const value = span.getAttribute("data-value");
	if (!value) {
		console.warn("No data-value attribute found on style element", span);
		return null;
	}
	// Convert the display value to the key format used in hatStyles
	// "Snapback" -> "snapback"
	// "Snapback Curved" -> "snapbackCurved"
	// "Dad Hat" -> "dadHat"
	// "5 Panel" -> "5Panel"
	// "Knit Beanies" -> "knitBeanies"
	const styleMap: { [key: string]: string } = {
		Snapback: "snapback",
		"Snapback Curved": "snapbackCurved",
		Fitted: "fitted",
		"Dad Hat": "dadHat",
		"5 Panel": "5Panel",
		"Knit Beanies": "knitBeanies",
	};

	const mappedStyle = styleMap[value];
	if (!mappedStyle) {
		console.warn(`Unknown style value: "${value}"`);
		return null;
	}

	return mappedStyle;
}
